import { render } from "./Plugins.vue?vue&type=template&id=d75aa0f6"
import script from "./Plugins.vue?vue&type=script&lang=ts"
export * from "./Plugins.vue?vue&type=script&lang=ts"
script.render = render

export default script